module.exports = __webpack_public_path__ + "media/fonts/lineto-circular-book-20830907.svg";